<template>
  <div class="user-address-manager">
    <Navbar left-text title="地址管理" />
    <a @click="fillAddressHandler" class="add-address" href="javascript:;">
      <div>
        <img alt class="add" src="../assets/img/add-icon.png" />
        <span>新增地址</span>
      </div>
      <img alt class="arrow-right" src="../assets/img/arrow-right.png" />
    </a>
    <div class="address-list">
      <a
        :key="index"
        @click="switchAddress(index)"
        class="address-intro"
        href="javascript:;"
        v-for="(address, index) in addressList"
      >
        <div class="title">
          <div class="name">{{ address.name }}</div>
          <div class="phone">{{ address.mobile }}</div>
        </div>
        <div class="address-details">{{ address | addressDetails }}</div>
        <div class="address-status">
          <div class="check-status">
            <span :class="{ checked: current == index }" class="check"></span>
            <span>使用该地址</span>
          </div>
          <button
            @click.stop="delAddressHandler(address.id)"
            class="del-address"
          >
            <img alt src="../assets/img/del-ad.png" />
            删除
          </button>
        </div>
      </a>
    </div>
    <div class="footer">
      <button @click="continueHandler" class="continue">继续</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
let flag = false
export default {
  name: 'userAddressManager',

  props: {
    callback: {
      type: String
    },
    type: {
      type: String
    },
    platformName: {
      type: String
    },
    platformType: {
      type: String
    },
    platformBrand: {
      type: String
    },

    oid: {
      type: String
    },
    sa: String,
    sb: String,
    se: String
  },
  data () {
    return {
      addressList: [],
      current: null
    }
  },

  filters: {
    addressDetails (address) {
      const townName = address.town_name !== '0' ? address.town_name : ''
      return address.province_name + address.city_name + address.district_name + townName + address.address_detail
    }
  },

  created () {
    this.getUserAddress()
  },

  methods: {
    ...mapActions('hornorBuy', [
      'editHornorBuyAddressHandler'
    ]),

    switchAddress (index) {
      this.current = index
    },

    updateAddressList (id) {
      this.addressList = this.addressList.filter((v) => v.id !== id)
    },

    /**
     * 继续
     */
    async continueHandler () {
      if (this.current !== null) {
        const userAddress = this.addressList.find((v, i) => i === this.current)
        if (this.callback) {
          await this.editHornorBuyAddressHandler({ address: userAddress })
          this.$router.back()
        } else {
          const status = await this.updateTempOrder(userAddress.id)
          if (status) {
            this.$router.back()
          }
        }
      } else {
        this.$toast('请选择使用地址')
      }
    },

    /**
     * 填写地址
     */
    fillAddressHandler () {
      this.$router.push({ name: 'fillAnAddress', query: this.$route.query })
    },

    /**
     * 更新临时订单(更新地址)
     * @param { String } id 地址id
     */
    async updateTempOrder (id) {
      this.$toast.loading('正在更新地址, 请稍候...')
      const res = await this.$axios.post('api/order/2.0/uto', {
        type: this.type,
        data: {
          id: this.oid,
          address: {
            id,
            platform: this.platformName,
            addr_data: this.platformType
          },
          sa: this.sa === 'true',
          sb: this.sb === 'true',
          se: this.se === 'true'
        }
      })
      if (res.status === 200) {
        const { code, msg } = res.data
        if (code !== 0) {
          this.$toast(msg)
          return false
        } else {
          return true
        }
      }
    },

    /**
     * 获取用户平台地址列表
     */
    async getUserAddress () {
      this.$toast.loading('正在加载...')
      const res = await this.$axios.get(`api/address/list/${this.platformType}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        if (code === 0) {
          this.addressList = data
        } else if (code === 9006) {
        } else {
          this.$toast(msg)
        }
      }
    },

    async delAddressHandler (id) {
      if (flag) {
        return false
      }
      flag = true
      const res = await this.$axios.post('api/address/del', { id })
      if (res.status === 200) {
        flag = false
        const { code, msg } = res.data
        if (code === 0) {
          this.$toast('删除成功')
          this.updateAddressList(id)
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.user-address-manager {
  padding-bottom: 0.88rem;
}
.add-address {
  padding: 0 0.4rem;
  height: 0.88rem;
  margin: 0.2rem 0 0.34rem;
  background-color: #fff;
  border-top: 0.5px solid #cdcdcd;
  border-bottom: 0.5px solid #cdcdcd;
  .flex-between;
  font-size: @fz28;
  font-weight: bold;
  color: @base;
  .add {
    width: 0.42rem;
    margin-right: 0.3rem;
  }
  .arrow-right {
    width: 0.25rem;
    object-fit: contain;
  }
}
.address-list {
  .address-intro {
    background-color: #fff;
    margin-bottom: 0.2rem;
    .title {
      padding: 0.35rem 0.4rem 0.3rem;
      font-weight: bold;
      font-size: @fz32;
      color: @base;
      padding-bottom: 0.3rem;
      .flex-between;
      border-top: 0.5px solid #c0c0c0;
    }
    .address-details {
      font-size: @fz28;
      color: #666;
      padding: 0 0.4rem 0.42rem;
    }
    .address-status {
      padding: 0 0.4rem;
      font-size: @fz26;
      color: @base;
      height: 0.92rem;
      border-top: 0.5px solid #c0c0c0;
      border-bottom: 0.5px solid #c0c0c0;
      .flex-between;
      .check-status {
        display: flex;
        align-items: center;
        .check,
        .checked {
          margin-right: 0.15rem;
          width: 0.4rem;
          height: 0.4rem;
          background: url('../assets/img/radio-unchecked-ad.png') center
            no-repeat;
          background-size: 100%;
        }
        .checked {
          background: url('../assets/img/radio-checked-ad.png') center no-repeat;
          background-size: 100%;
        }
      }
    }
    .del-address {
      .flex-center;
      img {
        width: 0.25rem;
        height: 0.25rem;
        padding-right: 0.1rem;
      }
    }
  }
}
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 0.88rem;
  background-color: #fff;
  text-align: right;
  button {
    width: 1.72rem;
    height: 0.88rem;
    background-color: #ff3824;
    font-size: @fz28;
    color: #fff;
  }
}
</style>
